import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UiModule } from '@ov-suite/ui';
import { InventoryHeldByUserListComponent } from './list/inventory-held-by-user-list.component';
import { InventoryHeldByUserRoutes } from './inventory-held-by-user.routing';

@NgModule({
  imports: [CommonModule, RouterModule.forChild(InventoryHeldByUserRoutes), FormsModule, UiModule],
  declarations: [InventoryHeldByUserListComponent],
})
export class InventoryHeldByUserModule {}
